import { toast } from "@/ui-plus/sonner";
import {
    setCachedStoreOrders,
    setLoadOrders
} from "@/orders-manager/order-modal/refHelps";
import { storeOrdersApiClient } from "@api-client/store_orders";
import { ref } from "vue";
import type { ResType } from "@api-client/typeUtils";
import { MySettingsStore } from "./MySettingsStore";
import { checkNewOrders } from "./playAudio";
import { NOT_AUTHENTICATED } from "@lib/consts/authConsts";

const ApiPath = storeOrdersApiClient[":storeId"].get_by_order_ids.$post;
type RecentOrdersType = ResType<typeof ApiPath>["data"];

const recentOrdersIds = ref<{
    order_placed_at_ts: number;
    storeOrderId: string;
}[]>([]);
export const cachedStoreOrders = ref<Record<string, RecentOrdersType[number]>>({});

let autoLoadTimer: ReturnType<typeof setTimeout> | null = null
export const refreshRecentOrderIds = async (storeId: string) => {
    if (autoLoadTimer) {
        clearTimeout(autoLoadTimer);
    }
    if (!MySettingsStore.value[storeId]?.isEnabled) return;
    const { data, error } = await (await storeOrdersApiClient[":storeId"].recent_orders.$post({
        param: { storeId },
        json: {
            start: undefined,
            end: undefined,
        }
    })).json();
    if (error) {
        toast.error(error.message ?? "Error fetching recent orders");
        setTimeout(() => {
            if (error.code === NOT_AUTHENTICATED) {
                window.location.reload();
            }
        }, 2000);
    } else {
        const newOrderIds: string[] = [];
        recentOrdersIds.value = data;
        data.forEach((order) => {
            // filter new and updated orders from cached orders
            const cachedOrder = cachedStoreOrders.value[order.storeOrderId];
            if (!cachedOrder || cachedOrder.updated_at_ts !== order.updated_at_ts) {
                newOrderIds.push(order.storeOrderId);
            }
        });
        // load new and updated orders
        if (newOrderIds.length > 0) {
            loadOrders(storeId, newOrderIds);
        }
    }

    autoLoadTimer = setTimeout(() => {
        refreshRecentOrderIds(storeId);
    }, 5 * 60_000); // 5 minutes
}

export const loadOrders = async (storeId: string, newOrderIds: string[], callback?: () => void) => {
    const { data, error } = await (await storeOrdersApiClient[":storeId"].get_by_order_ids.$post({
        param: { storeId },
        json: {
            orderIds: newOrderIds,
            // columns: {
            //     storeOrderId: true,
            //     orderType: true,
            //     orderStatus: true,
            //     orderTotal: true,
            //     orderNote: true,
            //     orderCreatedAtTs: true,
            //     orderUpdatedAtTs: true,
            //     orderCreatedAt: true,
            //     orderUpdatedAt: true,
            //     order_placed_at_ts: true,
            // }
        },

    })).json();
    if (error) {
        toast.error(error.message ?? "Error fetching recent orders");
        return;
    } else {
        data.forEach((order) => {
            order.statusHistory.sort((a, b) => a.created_at_ts - b.created_at_ts);
            cachedStoreOrders.value[order.storeOrderId] = order;
        });
        setTimeout(() => {
            checkNewOrders();
        }, 1000);
    }
    callback?.();
}

setCachedStoreOrders(cachedStoreOrders);
setLoadOrders(loadOrders);